module.exports = __webpack_public_path__ + "media/img/aconitas-logo-3f408ca968b7a83b7594717ab883e516.png";